import { weakMapMemoize } from '@reduxjs/toolkit';
import type { ComponentDescription } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import type { ComponentTemplate } from '../../components/types';
import migrateComponentInstance from '../../components/utils/migrateComponentInstance';

const getCompositeTemplateFromDescription = weakMapMemoize(
  (compositeDescription: ComponentDescription): ComponentTemplate | null => {
    const compositeJson = compositeDescription.composite_json;
    if (!compositeJson) return null;
    if (typeof compositeJson === 'string') {
      try {
        // TODO: Validate with Zod!
        return JSON.parse(compositeJson);
      } catch (cause) {
        throw new Error(`Component description "${compositeDescription.name}" has invalid composite template`, {
          cause,
        });
      }
    }
    // TODO: Validate with Zod!
    const { component, flows } = compositeJson;
    return {
      component: migrateComponentInstance(component),
      flows,
    };
  },
);

export default getCompositeTemplateFromDescription;
